"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HrElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _slateReact = require("slate-react");
var _jsxRuntime = require("react/jsx-runtime");
var HrElement = exports.HrElement = (0, _cn.withRef)(function (_ref, ref) {
  var className = _ref.className,
    nodeProps = _ref.nodeProps,
    props = _objectWithoutProperties(_ref, ["className", "nodeProps"]);
  var children = props.children;
  var selected = (0, _slateReact.useSelected)();
  var focused = (0, _slateReact.useFocused)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_plateCommon.PlateElement, _objectSpread({
    ref: ref
  }, props, {
    className: 'slate-draftjs-ignore',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("hr", _objectSpread({}, nodeProps, {
      className: (0, _cn.cn)('h-0.5 cursor-pointer rounded-sm border-none bg-muted bg-clip-content', selected && focused && 'ring-2 ring-ring ring-offset-2', className)
    })), children]
  }));
});